"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateMoveToNodeIds = exports.setNoPermissionMembers = exports.setPermissionCommitRemindParameter = exports.setPermissionCommitRemindStatus = exports.updateNodeInfo = exports.getNodeInfo = exports.setLoadedKeys = exports.setActiveNodeError = exports.initFavoriteTreeNodes = exports.moveFavoriteNode = exports.deleteNodeFromFavoriteList = exports.removeFavorite = exports.addNodeToFavoriteTree = exports.generateFavoriteTree = exports.collectionNodeAndExpand = exports.deleteNode = exports.refreshTree = exports.updateTreeNodesMap = exports.updateIsPermission = exports.deleteNodeAction = exports.removeNodeFromTree = exports.removeNodeFromMap = exports.initCatalogTree = exports.clearNode = exports.moveTo = exports.setTreeLoading = exports.updateHasChildren = exports.getChildNode = exports.setNodeErrorType = exports.setNodeName = exports.updateSocketData = exports.addNode = exports.addNodeToMap = exports.setExpandedKeys = exports.updateImportModalNodeId = exports.updateSaveAsTemplateModalNodeId = exports.updateShareModalNodeId = exports.updatePermissionModalNodeId = exports.setTreeRootId = exports.setCopyNodeId = exports.setDelNodeId = exports.setEditNodeId = exports.setErr = void 0;
const interfaces_1 = require("../../../../exports/store/interfaces");
const actions_1 = require("../../../../exports/store/actions");
const actions = __importStar(require("../../../shared/store/action_constants"));
const redux_batched_actions_1 = require("redux-batched-actions");
const api_1 = require("../../../../exports/api");
const utils_1 = require("../../../../utils");
const form_1 = require("../../../database/store/actions/resource/form/form");
const config_1 = require("../../../../config");
const store_1 = require("../../../../exports/store");
/**
 * Set Error Message
 *
 * @param err
 */
function setErr(err) {
    return {
        type: actions.SET_ERR,
        payload: err,
    };
}
exports.setErr = setErr;
/**
 * set current edit state node ID
 *
 * @param nodeId Node ID
 */
function setEditNodeId(nodeId, module = config_1.ConfigConstant.Modules.CATALOG) {
    return {
        type: actions.SET_EDIT_NODE_ID,
        payload: {
            nodeId,
            module,
        },
    };
}
exports.setEditNodeId = setEditNodeId;
/**
 * Set the node ID to delete
 *
 * @param nodeId Node ID
 */
function setDelNodeId(nodeId, module = config_1.ConfigConstant.Modules.CATALOG) {
    return {
        type: actions.SET_DEL_NODE_ID,
        payload: { nodeId, module },
    };
}
exports.setDelNodeId = setDelNodeId;
/**
 * set the node ID to copy
 *
 * @param nodeId Node ID
 */
function setCopyNodeId(nodeId) {
    return {
        type: actions.SET_COPY_NODE_ID,
        payload: nodeId,
    };
}
exports.setCopyNodeId = setCopyNodeId;
/**
 * Set the root Node ID
 *
 * @param nodeId
 * @returns
 */
const setTreeRootId = (nodeId) => {
    return {
        type: actions.SET_TREE_ROOT_ID,
        payload: nodeId,
    };
};
exports.setTreeRootId = setTreeRootId;
/**
 * Current Node that is opening permission UI window
 * @param nodeId Node ID
 */
function updatePermissionModalNodeId(nodeId) {
    return {
        type: actions.UPDATE_PERMISSION_MODAL_NODE_ID,
        payload: nodeId,
    };
}
exports.updatePermissionModalNodeId = updatePermissionModalNodeId;
/**
 * Current node that is opening share window.
 * @param nodeId Node ID
 */
function updateShareModalNodeId(nodeId) {
    return {
        type: actions.UPDATE_SHARE_MODAL_NODE_ID,
        payload: nodeId,
    };
}
exports.updateShareModalNodeId = updateShareModalNodeId;
/**
 * Current node that is opening save as template window.
 *
 * @param nodeId
 */
function updateSaveAsTemplateModalNodeId(nodeId) {
    return {
        type: actions.UPDATE_SAVE_AS_TEMPLATE_MODAL_NODE_ID,
        payload: nodeId,
    };
}
exports.updateSaveAsTemplateModalNodeId = updateSaveAsTemplateModalNodeId;
/**
 * Current node that is opening the import UI window.
 *
 * @param nodeId Node ID
 */
function updateImportModalNodeId(nodeId) {
    return {
        type: actions.UPDATE_IMPORT_MODAL_NODE_ID,
        payload: nodeId,
    };
}
exports.updateImportModalNodeId = updateImportModalNodeId;
/**
 * Set the array of expanded nodes
 *
 * @param expandedKeys the keys array of expanded nodes
 */
function setExpandedKeys(expandedKeys, module = config_1.ConfigConstant.Modules.CATALOG) {
    return {
        type: actions.SET_EXPANDED_KEYS,
        payload: {
            expandedKeys,
            module,
        },
    };
}
exports.setExpandedKeys = setExpandedKeys;
/**
 * add single or multiple nodes to treeNodeMap (catalog tree data source)
 *
 * @param Node Single node or collection of nodes
 */
const addNodeToMap = (data, isCoverChildren = true) => {
    return {
        type: actions.ADD_NODE_TO_MAP,
        payload: { data, isCoverChildren },
    };
};
exports.addNodeToMap = addNodeToMap;
/**
 * add nodes to files tree(catalog)
 *
 * @param node the node info of new
 */
const addNode = (node) => {
    return (dispatch) => {
        dispatch((0, redux_batched_actions_1.batchActions)([(0, exports.addNodeToMap)([node]), setEditNodeId(node.nodeId)], 'ADD_NODE'));
    };
};
exports.addNode = addNode;
/**
 * update treeNodeMap (catalog tree data source) by socket data
 * @param data
 * @returns
 */
const updateSocketData = (data) => {
    return {
        type: actions.UPDATE_SOCKET_DATA,
        payload: data,
    };
};
exports.updateSocketData = updateSocketData;
/**
 * set the name of node
 *
 * @param nodeId Node ID
 * @param nodeName Node Name
 */
function setNodeName(nodeId, nodeName) {
    return {
        type: actions.SET_NODE_NAME,
        payload: {
            nodeId,
            nodeName,
        },
    };
}
exports.setNodeName = setNodeName;
function setNodeErrorType(nodeId, errType) {
    return {
        type: actions.SET_NODE_ERROR_TYPE,
        payload: {
            nodeId,
            errType,
        },
    };
}
exports.setNodeErrorType = setNodeErrorType;
/**
 * get specified node's child nodes.
 * and attach them to files tree.
 *
 * @param nodeId Node ID
 */
function getChildNode(nodeId) {
    return (dispatch, getState) => __awaiter(this, void 0, void 0, function* () {
        const state = getState();
        const { loadedKeys } = state.catalogTree;
        dispatch((0, exports.setTreeLoading)(true));
        const nodeData = yield getChildNodeList(nodeId);
        if (nodeData === interfaces_1.NodeErrorType.ChildNodes) {
            dispatch((0, exports.setTreeLoading)(false));
            dispatch(setNodeErrorType(nodeId, interfaces_1.NodeErrorType.ChildNodes));
            return;
        }
        if (!nodeData || (Array.isArray(nodeData) && !nodeData.length)) {
            dispatch((0, exports.setTreeLoading)(false));
            dispatch(setLoadedKeys([...loadedKeys, nodeId]));
            dispatch(setNodeErrorType(nodeId, null));
            return;
        }
        // update current node has child nodes
        dispatch((0, exports.addNodeToMap)(store_1.Selectors.flatNodeTree(nodeData), false));
        dispatch(updateHasChildren(nodeId));
        dispatch(setNodeErrorType(nodeId, null));
        dispatch((0, exports.setTreeLoading)(false));
    });
}
exports.getChildNode = getChildNode;
/**
 * update node's hasChildren state
 *
 * @param nodeId the node that want to update
 */
function updateHasChildren(nodeId) {
    return {
        type: actions.UPDATE_HAS_CHILDREN,
        payload: nodeId,
    };
}
exports.updateHasChildren = updateHasChildren;
/**
 * get specified node's child nodes.
 * @param nodeId
 * @returns
 */
const getChildNodeList = (nodeId) => {
    return api_1.Api.getChildNodeList(nodeId).then(res => {
        const { success, data } = res.data;
        if (success) {
            return data;
        }
        return interfaces_1.NodeErrorType.ChildNodes;
    }).catch(() => interfaces_1.NodeErrorType.ChildNodes);
};
/**
 * the loading state of current files tree.
 *
 * @param loading
 * @param module
 * @returns
 */
const setTreeLoading = (loading, module = config_1.ConfigConstant.Modules.CATALOG) => {
    return {
        type: actions.TREE_LOADING,
        payload: {
            loading,
            module,
        },
    };
};
exports.setTreeLoading = setTreeLoading;
/**
 * move node to specified position
 *
 * @param {string} nodeId Node ID
 * @param {string} targetNodeId target node ID
 * @param {number} pos -1: above the target node | 0：move into target node | 1：below the target node
 * @returns
 */
const moveTo = (nodeId, targetNodeId, pos) => {
    return {
        type: actions.NODE_MOVE_TO,
        payload: {
            nodeId,
            targetNodeId,
            pos,
        },
    };
};
exports.moveTo = moveTo;
/**
 * clear node attribute
 */
const clearNode = () => {
    return {
        type: actions.CLEAR_NODE,
    };
};
exports.clearNode = clearNode;
/**
 * init files tree(catalog)
 */
function initCatalogTree() {
    return {
        type: actions.INIT_CATALOG_TREE,
    };
}
exports.initCatalogTree = initCatalogTree;
/**
 * remove single or multi nodes from treeNodeMap(catalog tree data source)
 * @param Node single node or collection of nodes
 */
const removeNodeFromMap = (nodeId) => {
    return {
        type: actions.REMOVE_NODE_FROM_MAP,
        payload: nodeId,
    };
};
exports.removeNodeFromMap = removeNodeFromMap;
/**
 * remove single or multi nodes from tree
 * @param data single node or collection of nodes
 */
const removeNodeFromTree = (nodeId) => {
    return {
        type: actions.REMOVE_NODE_FROM_TREE,
        payload: nodeId,
    };
};
exports.removeNodeFromTree = removeNodeFromTree;
/**
 * delete node
 * @param optNode
 */
function deleteNodeAction(optNode) {
    return {
        type: actions.DELETE_NODE,
        payload: optNode,
    };
}
exports.deleteNodeAction = deleteNodeAction;
/**
 * update the state of `isPermission`
 */
function updateIsPermission(status) {
    return {
        type: actions.UPDATE_IS_PERMISSION,
        payload: status,
    };
}
exports.updateIsPermission = updateIsPermission;
/**
 * update specify nodes in treeNodeMap
 *
 * @param nodeId Node ID
 * @param data new data
 */
const updateTreeNodesMap = (nodeId, data) => {
    return {
        type: actions.UPDATE_TREE_NODES_MAP,
        payload: {
            nodeId,
            data,
        },
    };
};
exports.updateTreeNodesMap = updateTreeNodesMap;
/**
 * refresh tree (some layer)
 *
 * @param data
 */
const refreshTree = (data) => {
    return {
        type: actions.REFRESH_TREE,
        payload: data,
    };
};
exports.refreshTree = refreshTree;
/**
 * Delete node from the files tree(catalog)
 *
 * @param optNode the node info that is under operation.
 */
const deleteNode = (optNode) => {
    const actions = [
        deleteNodeAction(optNode),
        deleteNodeFromFavoriteList(optNode),
        setDelNodeId(''),
        setDelNodeId('', config_1.ConfigConstant.Modules.FAVORITE),
    ];
    return (dispatch) => {
        dispatch((0, redux_batched_actions_1.batchActions)(actions));
    };
};
exports.deleteNode = deleteNode;
/**
 * find the path of the node by parentId, and expand all the folders on them.
 *
 * @param nodeId Node ID
 */
const collectionNodeAndExpand = (nodeId) => {
    return (dispatch, getState) => {
        const state = getState();
        const { rootId, expandedKeys, treeNodesMap, favoriteExpandedKeys, favoriteTreeNodeIds } = state.catalogTree;
        const newExpandKeys = [...(new Set([...expandedKeys, ...(0, utils_1.getExpandNodeIds)(treeNodesMap, nodeId, rootId)]))];
        const newFavoriteExpandKeys = [...(new Set([...favoriteExpandedKeys, ...(0, utils_1.getExpandNodeIds)(treeNodesMap, nodeId, rootId, favoriteTreeNodeIds)]))];
        dispatch(setExpandedKeys(newExpandKeys));
        dispatch(setExpandedKeys(newFavoriteExpandKeys, config_1.ConfigConstant.Modules.FAVORITE));
    };
};
exports.collectionNodeAndExpand = collectionNodeAndExpand;
/**
 * generate favorite (star)
 * @param node
 * @returns
 */
const generateFavoriteTree = (node) => {
    return (dispatch) => {
        dispatch((0, exports.addNodeToMap)(node));
        const nodeIds = node.map(item => item.nodeId);
        dispatch((0, exports.addNodeToFavoriteTree)(nodeIds));
    };
};
exports.generateFavoriteTree = generateFavoriteTree;
/**
 * add favorite(star) into the specified node
 * @param nodeIds
 * @param parentId
 * @returns
 */
const addNodeToFavoriteTree = (nodeIds, parentId = '') => {
    return {
        type: actions.ADD_NODE_TO_FAVORITE_LIST,
        payload: {
            nodeIds,
            parentId,
        },
    };
};
exports.addNodeToFavoriteTree = addNodeToFavoriteTree;
/**
 * remove favorite (star)
 * @param nodeId
 * @returns
 */
const removeFavorite = (nodeId) => {
    return (dispatch, getState) => {
        const state = getState();
        const type = state.catalogTree.treeNodesMap[nodeId].type;
        dispatch((0, exports.updateNodeInfo)(nodeId, type, { nodeFavorite: false }));
        dispatch({
            type: actions.DELETE_NODE_FROM_FAVORITE_LIST,
            payload: { nodeId },
        });
    };
};
exports.removeFavorite = removeFavorite;
function deleteNodeFromFavoriteList(optNode) {
    return {
        type: actions.DELETE_NODE_FROM_FAVORITE_LIST,
        payload: optNode,
    };
}
exports.deleteNodeFromFavoriteList = deleteNodeFromFavoriteList;
function moveFavoriteNode(nodeId, preNodeId) {
    return {
        type: actions.MOVE_FAVORITE_NODE,
        payload: {
            nodeId,
            preNodeId,
        },
    };
}
exports.moveFavoriteNode = moveFavoriteNode;
function initFavoriteTreeNodes() {
    return {
        type: actions.INIT_FAVORITE_TREE_NODES,
    };
}
exports.initFavoriteTreeNodes = initFavoriteTreeNodes;
function setActiveNodeError(status) {
    return {
        type: actions.SET_ACTIVE_NODE_ERROR,
        payload: status,
    };
}
exports.setActiveNodeError = setActiveNodeError;
function setLoadedKeys(keys) {
    return {
        type: actions.SET_LOADED_KEYS,
        payload: keys,
    };
}
exports.setLoadedKeys = setLoadedKeys;
/**
 * get single node info, put it in data source
 * @param nodeId
 * @returns
 */
const getNodeInfo = (nodeId) => {
    return (dispatch) => {
        api_1.Api.getNodeInfo(nodeId).then(res => {
            const { success, data } = res.data;
            if (success) {
                dispatch((0, exports.addNodeToMap)(data));
            }
        }, err => {
            console.error('API.getNodeInfo error', err);
        });
    };
};
exports.getNodeInfo = getNodeInfo;
/**
 * update data source
 * for example, the data source of datasheet / form...
 * @param nodeId
 * @param nodeType
 * @param data
 * @returns
 */
const updateNodeInfo = (nodeId, nodeType, data) => {
    return (dispatch) => {
        switch (nodeType) {
            case config_1.ConfigConstant.NodeType.DATASHEET: {
                dispatch((0, actions_1.updateDatasheet)(nodeId, data));
                break;
            }
            case config_1.ConfigConstant.NodeType.FORM: {
                dispatch((0, form_1.updateForm)(nodeId, data));
                break;
            }
            case config_1.ConfigConstant.NodeType.DASHBOARD: {
                dispatch((0, actions_1.updateDashboard)(nodeId, data));
                break;
            }
            case config_1.ConfigConstant.NodeType.MIRROR: {
                dispatch((0, actions_1.updateMirror)(nodeId, data));
                break;
            }
        }
        const { name } = data, info = __rest(data, ["name"]);
        const nodeData = name ? Object.assign(Object.assign({}, info), { nodeName: name }) : info;
        dispatch((0, exports.updateTreeNodesMap)(nodeId, nodeData));
    };
};
exports.updateNodeInfo = updateNodeInfo;
/**
 * set permissions, whether or not to send a notification when popup window closed.
 *
 * @param status
 * @returns
 */
function setPermissionCommitRemindStatus(status) {
    return {
        type: actions.SET_PERMISSION_COMMIT_REMIND_STATUS,
        payload: status
    };
}
exports.setPermissionCommitRemindStatus = setPermissionCommitRemindStatus;
/**
 * set commenter change remind params by yiliu
 * @param Param
 * @returns
 */
function setPermissionCommitRemindParameter(Param) {
    return {
        type: actions.SET_PERMISSION_COMMIT_REMIND_PARAMETER,
        payload: Param
    };
}
exports.setPermissionCommitRemindParameter = setPermissionCommitRemindParameter;
/**
 * set members that no permission
 * @param Param
 * @returns
 */
function setNoPermissionMembers(Param) {
    return {
        type: actions.SET_NO_PERMISSION_MEMBERS,
        payload: Param
    };
}
exports.setNoPermissionMembers = setNoPermissionMembers;
/**
 * update the node that will move.
 *
 * @param nodeIds
 */
function updateMoveToNodeIds(nodeIds) {
    return {
        type: actions.UPDATE_MOVE_TO_NODE_IDS,
        payload: nodeIds,
    };
}
exports.updateMoveToNodeIds = updateMoveToNodeIds;
//# sourceMappingURL=catalog_tree.js.map